import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2ad6ccd5")

_pushScopeId("data-v-2ad6ccd5")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = { class: "series__group" }
const _hoisted_4 = {
  key: 0,
  class: "no-data"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, "Aucun match enregistré", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheSeriesDiagram = _resolveComponent("TheSeriesDiagram")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (!_ctx.divisions.length)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedDivisions, (name) => {
          return (_openBlock(), _createBlock("div", { key: name }, [
            _createVNode(_component_TheSeriesDiagram, {
              filterSetName: _ctx.filterSet(name),
              division: name,
              series: _ctx.seriesFromName(name),
              collapsed: _ctx.collapsedMap[name],
              onToggle: (ev) => _ctx.setDivisionCollapsed(name, ev)
            }, null, 8, ["filterSetName", "division", "series", "collapsed", "onToggle"])
          ]))
        }), 128))
      ])
    ])
  ]))
})